import { render, staticRenderFns } from "./initial.vue?vue&type=template&id=290c4108&scoped=true&lang=html&"
import script from "./initial.vue?vue&type=script&lang=js&"
export * from "./initial.vue?vue&type=script&lang=js&"
import style0 from "./initial.vue?vue&type=style&index=0&id=290c4108&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290c4108",
  null
  
)

component.options.__file = "initial.vue"
export default component.exports